import {
	notificationsCollection,
	firebase,
	usersCollection,
	groupsCollection,
} from '../../config/firebase';

let state = {
	notification: {},
	notifications: [],
	featuredNotifications: [],
	loading: false,
	notification: { message: '', type: '' },
};
let getters = {
	notification: state => state.notification,
	notifications: state => state.notifications,
	notificationLoading: state => state.loading,
	notificationNotification: state => state.notification,
};
let actions = {
	async getNotification({ commit }, payload) {
		commit('setNotificationLoading', true);
		let notificationSnap = await notificationsCollection.doc(payload).get();
		let notificationData = notificationSnap.data();
		let { user } = notificationData;
		let userSnap = await usersCollection.doc(user).get();
		let userData = userSnap.data();
		notificationData['name'] = userData.firstname + ' ' + userData.lastname;
		notificationData['profile_image'] = userData['profile_image'];
		commit('setNotificationData', notificationData);
		commit('setNotificationLoading', false);
	},
	async getNotifications({ commit }, payload) {
		commit('setNotificationLoading', true);
		notificationsCollection
			.where('for', '==', payload)
			.orderBy('datetime', "desc")
			.onSnapshot(async snapshot => {
				let notifications = [];
				for (let doc of snapshot.docs) {
					let data = doc.data();
					let { user } = data;
					let userSnap = await usersCollection.doc(user).get();
					let userData = userSnap.data();
					data['name'] = userData.firstname + ' ' + userData.lastname;
					data['profile_image'] = userData['profile_image'];
					if(data.type == "group"){
						let groupSnap = await groupsCollection.doc(data.group).get();
						let groupData = groupSnap.data();
						data["group_id"] = data.group ;
						data["group"] = groupData.name ;
					}
					notifications.push({ id: doc.id, ...data });
				}
				commit('setNotificationsData', notifications);
				commit('setNotificationLoading', false);
			});
	},
	async setNotification({ commit }, payload) {
		commit('setNotificationLoading', true);
		payload['isRead'] = false;
		payload['datetime'] = firebase.firestore.Timestamp.fromDate(new Date());
		await notificationsCollection.add({ ...payload });
		commit('setNotificationLoading', false);
	},
	async readNotifications({commit}, payload){
		
		let notificationSnap = await notificationsCollection.where("for","==",payload).get();
		for(let doc of notificationSnap.docs){
			let id = doc.id;
			await notificationsCollection.doc(id).update({...notificationSnap.data, isRead:true});
		}
	},
	async updateNotification({ commit }, payload) {
		commit('setNotificationLoading', true);
		await notificationsCollection.doc(payload).update({ isRead: true });
		commit('setNotificationLoading', false);
	},
};
let mutations = {
	setNotificationData(state, payload) {
		state.notification = payload;
	},
	setNotificationsData(state, payload) {
		state.notifications = payload;
	},
	setFeaturedNotificationsData(state, payload) {
		state.featuredNotifications = payload;
	},
	setNotificationLoading(state, payload) {
		state.loading = payload;
	},
	setNotificationsNotification(state, payload) {
		let { notification } = state;
		notification.message = payload.message;
		notification.type = payload.type;
		state.notification = notification;
		window.setTimeout(() => {
			let obj = { message: '', type: '' };
			state.notification = obj;
		}, 5000);
	},
};
export default { state, getters, actions, mutations };
